import { Text } from "components/UI";
import VideoIcon from "assets/images/icons/video.png";
import ImageIcon from "assets/images/icons/image.png";
import TxtIcon from "assets/images/icons/txt.png";
import XlsxIcon from "assets/images/icons/xls.png";
import DocxIcon from "assets/images/icons/docx.png";
import AudioIcon from "assets/images/icons/audio.png";
import PdfIcon from "assets/images/icons/pdf.png";
import PPTXIcon from "assets/images/icons/pptx.png";
import { useCallback, useMemo } from "react";
import {
  audioExtention,
  docExtention,
  imageExtention,
  pptExtention,
  txtExtention,
  videoExtention,
  xlsExtention,
} from "utils/static";
import { getExtention } from "utils/helper";
import { includes, isEmpty } from "lodash-es";

const FileMessage = ({ message, isReply, text = "" }) => {
  const extension = useMemo(
    () => getExtention(message.media_document_filename || ""),
    [message.media_document_filename]
  );

  const clickHandler = useCallback(() => {
    window.open(message.media_url, "_blank");
  }, [message.media_url]);

  if (isReply) {
    return (
      <div className="flex flex-row space-x-1">
        <FileIcon className="h-[14px]" extension={extension} />
        <Text className="text-xs text-gray-600 whitespace-normal w-max">
          {message.media_document_filename}
        </Text>
      </div>
    );
  }

  return (
    <div className="">
      <div
        onClick={!isReply ? clickHandler : undefined}
        className="flex flex-row items-center space-x-2 bg-gray-200 p-3 rounded-lg cursor-pointer hover:bg-gray-100 transition-all duration-300 active:bg-gray-300"
      >
        <FileIcon
          className={isReply ? "h-[20px]" : "h-[40px]"}
          extension={extension}
        />
        <div className="flex flex-col">
          <Text className="text-xs text-gray-600">
            {message.media_document_filename}
          </Text>
        </div>
      </div>
      <div className="mt-2">
        {!isEmpty(message.message_text && text) && <Text>{text}</Text>}
        {isEmpty(message.message_text && text) && (
          <Text>{message.message_text}</Text>
        )}
      </div>
    </div>
  );
};

export const FileIcon = ({ extension, ...props }) => {
  const icon = useMemo(() => {
    if (extension === "pdf") {
      return PdfIcon;
    } else if (includes(xlsExtention, extension)) {
      return XlsxIcon;
    } else if (includes(docExtention, extension)) {
      return DocxIcon;
    } else if (includes(videoExtention, extension)) {
      return VideoIcon;
    } else if (includes(imageExtention, extension)) {
      return ImageIcon;
    } else if (includes(audioExtention, extension)) {
      return AudioIcon;
    } else if (includes(txtExtention, extension)) {
      return TxtIcon;
    } else if (includes(pptExtention, extension)) {
      return PPTXIcon;
    } else {
      return TxtIcon;
    }
  }, [extension]);

  return <img src={icon} className="h-[40px]" {...props} />;
};

export default FileMessage;
